import { CardType } from './payments';
export const iFrameAnalyticsEvents = ['credit-card.actions.post-page-error'];
export const INSTANT_CHECKOUT_OVERLAY = 'instant-checkout-page-modify-overlay';
export const INSTANT_CHECKOUT_POST_PAGE_ERROR = 'instant-checkout-post-page-error';
export const INSTANT_CHECKOUT_CONTINUE_SHOPPING_LINK = 'instant-checkout-continue-shopping';
export const PHA_PAGE_LOAD_ERROR = 'pro-house-account.actions.page-load-error';
export const cardTypePageSectionMapping = {
    [CardType.CREDIT_CARD]: 'cards and accounts page',
    [CardType.GIFT_CARD]: 'cards and accounts page',
    [CardType.CHECKING_ACCOUNT]: 'cards and accounts page',
    [CardType.KEY_TAG]: 'cards and accounts page',
    [CardType.PRO_XTRA_DOLLARS]: 'cards and accounts page',
    [CardType.PAYPAL_ACCOUNT]: 'cards and accounts page',
    [CardType.PRO_HOUSE_ACCOUNT]: 'pro house account',
};
